export enum WorkflowTabVisibleKinds {
  All,
  Status,
  Finish,
  Suspend,
  Preset,
}
